/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_2_StateInputs */

const en_svc_agents_art_2_state = /** @type {(inputs: Svc_Agents_Art_2_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

const lv_svc_agents_art_2_state = /** @type {(inputs: Svc_Agents_Art_2_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atjaunināts`)
};

/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Svc_Agents_Art_2_StateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_2_state = /** @type {((inputs?: Svc_Agents_Art_2_StateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_2_StateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_2_state(inputs)
	return en_svc_agents_art_2_state(inputs)
});